<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <template v-for ="(link, index) in sidebar_modules" >
          <sidebar-item :link="link.link_data" :key="index" v-if="link.is_single_level"></sidebar-item>
          <sidebar-item  :link="link.link_data" :key="index" v-else>
            <sidebar-item v-for="(item, j) in link.items" :link="item.link_data" :key="j"/>
          </sidebar-item>
        </template>

      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <!-- <content-footer v-if="!$route.meta.hideFooter"></content-footer> -->
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';
  import { mapState } from "vuex";

  export default {
        computed:{
      ...mapState({
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        auth_user:state =>state.auth.auth_user
      }),
    },
    watch:{
          language_terms: {
            handler(val){
                this.displaySideBar()
            }
        }
    },
    data(){
      return{
        document_id:'1',
        sidebar_modules:[]

      }
    },
    components: {
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('sidenav');
        }
      },
      async displaySideBar()
      {
        await this.$store.dispatch("auth/getAuthUser");

        if (this.auth_user)
        {
          this.sidebar_modules = this.auth_user['modules']
        }
        else
        {
          this.sidebar_modules = []
        }
      }
    },
    async mounted() {
      let document_id = localStorage.getItem(document_id)
      this.initScrollbar()
      await this.displaySideBar()
    }
  };
</script>
<style lang="scss">
</style>
